import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { TempPasswordNotice } from "../components/order/TempPasswordNotice";
import AuthPage from "./hoc/AuthPage";
const WelcomePage = () => {
  return (
    <AuthPage>
      <h1 className="mb-5">Welcome!</h1>
      <p className="mb-5 lead">Already have an account?</p>
      <TempPasswordNotice />
      <Row>
        <Col>
          <Button
            as={Link}
            to="/login"
            size="lg"
            block
            className="welcome-button ml-auto"
          >
            Yes
          </Button>
        </Col>
        <Col>
          <Button
            as={Link}
            to="/no-account"
            size="lg"
            block
            className="welcome-button"
          >
            No
          </Button>
        </Col>
      </Row>
    </AuthPage>
  );
};

export default WelcomePage;
